import React from 'react'
import IconButton from './iconButton.jsx'
import symbols from './symbols'

class MaskedItem extends React.Component {
    render() {
        return (
            <span>
                <IconButton className="actual-dropdown-item" symbol={this.props.symbol} onClick={this.props.action}>{this.props.children}</IconButton>
                <IconButton className="selected-dropdown-item" symbol={this.props.maskSymbol || this.props.symbol} onClick={this.props.action}>
                    <span className="symbol-arrow-down floating" >
                        <svg className="symbol" {...symbols.arrowDown.svg}
                             dangerouslySetInnerHTML={{__html: symbols.arrowDown.content}}>
                        </svg>
                    </span>
                </IconButton>
            </span>
        )
    }
}


MaskedItem.propTypes = {
    symbol: React.PropTypes.string,
    maskSymbol: React.PropTypes.string,
    action: React.PropTypes.func
}

module.exports = MaskedItem



// WEBPACK FOOTER //
// ./src/components/toolbar/maskedItem.jsx